import { UitgezetteDienst } from "@/entities/dossier-overzicht";
import { RoleGate, UserRole } from "@/features/auth";
// import { BemensingStatusEnTooltip } from "./bemensing-status-en-tooltip";
import { BusEvacuatieStatusEnTooltip } from "./busevacuatie-status-en-tooltip";
import { KoffieStatusEnTooltip } from "./koffie-status-en-tooltip";

import { TvvStatusEnTooltip } from "./tvv-status-en-tooltip";
import { VosStatusEnTooltip } from "./vos-status-en-tooltip";

type UitgezetteDienstFactoryProps = {
    dienst: UitgezetteDienst;
};

export function UitgezetteDienstFactory({ dienst }: UitgezetteDienstFactoryProps) {
    switch (dienst.type) {
        case "koffie":
            return (
                <RoleGate roles={[UserRole.ALLEENLEZEN, UserRole.SUPPORTCONSULTANT, UserRole.KLANTENSERVICE, UserRole.REGIEVOERDER]}>
                    <KoffieStatusEnTooltip dienst={dienst} />
                </RoleGate>
            );
        case "tvv":
            return <TvvStatusEnTooltip dienst={dienst} />;
        case "busEvacuatie":
            return (
                <RoleGate roles={[UserRole.ALLEENLEZEN, UserRole.REGIEVOERDER, UserRole.TRANSVISION, UserRole.DEWIT]}>
                    <BusEvacuatieStatusEnTooltip dienst={dienst} />
                </RoleGate>
            );

        case "vos":
            return (
                <RoleGate roles={[UserRole.REGIEVOERDER, UserRole.SUPPORTCONSULTANT]}>
                    <VosStatusEnTooltip dienst={dienst} />
                </RoleGate>
            );
        default:
            return null;
    }
}
